<template>
  <div class="btn-group chooserdiv">
     <template v-for="btn in btns">
        <bbtn
            :key="btn.value"
            :type="((v==btn.value)&&(selectedclass!=null))?selectedclass:btn.type"
            :class="(v==btn.value)?'chosen':null"
            :size="size"
            :glyph="btn.glyph"
            :glyphfa="btn.glyphfa"
            :simplehint="btn.simplehint"
            :title="(btn.title==null)?((v==btn.value)?btn.hint:''):btn.title"
            :titlepos="btn.titlepos"
            :hint="(v==btn.value)?null:btn.hint"
            :disabled="disabled||btn.disabled"
            :badge="btn.badge"
            @click="(btn.action)?btn.action():select(btn.value)"
        ></bbtn>
     </template>
  </div>
</template>

<script>
export default {
  name: "Chooser",
  props:[ "buttons","value","disabled","size","selectedclass","maxrow"],
  data(){
    return {
      v: (this.value==null)?0:this.value
    };
  },
  methods:{
    select(a){
      this.v=a;
      this.$emit("input",this.v);
    },
    rowBtns:i=>{
      if ((this.maxrow==null)||(this.maxrow>this.btns.length))
        return this.btns;
    }
  },
  watch:{
    value(){
      this.v=this.value;
    }
  },
  computed:{
    btns(){
      return this.buttons.filter(a=>(a!=null)).map((a,key)=>{
        if (typeof a=="string")
          return {
            value:key,
            type:"default",
            title:a,
          };
        return {type:"default",value:key,...a};
      })
    },
  }
}
</script>

<style scoped>

  div.chooserdiv{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  div.chooserdiv button{
    flex-grow: 1;
  }

  div.chooserdiv button:focus{
    outline:none !important;
  }

</style>